import axios from 'axios';
import notificator from '../../services/notificator';
import socket from '../../services/socket';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    recreateGame: async (ctx, gameId) => {
      try {
        const { data } = await axios.post(`/lobby/${gameId}/recreate`, {});

        socket.emitRecreateGame(gameId, data.gameId);
      } catch (e) {
        console.log({ ...e });

        notificator.error('The game could not be re-created.');
      }
    },
    swapPlayers: async (ctx, payload) => {
      try {
        await axios.put(`/lobby/${payload.gameId}/swap-players`, {
          player1: payload.player1,
          player2: payload.player2,
        });

        socket.emitFetchState(payload.gameId);
      } catch (e) {
        console.log({ ...e });

        notificator.error('The players could not be swapped.');
      }
    },
    kickPlayer: async (ctx, payload) => {
      try {
        await axios({
          method: 'unlink',
          url: `/lobby/${payload.gameId}/kick/${payload.playerId}`,
        });

        socket.emitFetchState(payload.gameId);
      } catch (e) {
        console.log({ ...e });

        notificator.error('Could not kick the player.');
      }
    },
    lockGame: async (ctx, gameId) => {
      try {
        await axios({ method: 'lock', url: `/lobby/${gameId}` });

        socket.emitFetchState(gameId);
      } catch (e) {
        console.log({ ...e });

        notificator.error('Could not lock the game.');
      }
    },
    unlockGame: async (ctx, gameId) => {
      try {
        await axios({ method: 'unlock', url: `/lobby/${gameId}` });

        socket.emitFetchState(gameId);
      } catch (e) {
        console.log({ ...e });

        notificator.error('Could not unlock the game.');
      }
    },
    startGame: async (ctx, payload) => {
      try {
        await axios({
          method: 'put',
          url: `/game/${payload.gameId}/start`,
          data: {
            mordred: payload.hasMordred,
            morganaPercival: payload.hasMorganaAndPercival,
            oberon: payload.hasOberon,
            anonymousVotes: payload.votesAreAnonymous,
            failFromServantsDisallowed: !payload.goodGuysAreAllowedToFail,
          },
        });

        socket.emitFetchState(payload.gameId);
      } catch (e) {
        console.log({ ...e });

        notificator.error('Could not start the game.');
      }
    },
  },
};
